import { StateType } from 'typesafe-actions';
import { Middleware } from 'redux';

import rootReducer from './root-reducer';
import { fetchLocationsMiddleware } from './locations/middleware';
import * as locationsSelectors from './locations/selectors';
import * as locationsActions from './locations/actions';
import { fetchPlacesMiddleware } from './places/middleware';
import * as placesSelectors from './places/selectors';
import * as placesActions from './places/actions';
import * as usersActions from './users/actions';
import * as questionsActions from './questions/actions';
import * as reviewsActions from './reviews/actions';
import * as photosActions from './photos/actions';

import * as visitorCentersActions from './visitorCenters/actions';
import * as campgroundsActions from './campgrounds/actions';
import * as alertsActions from './alerts/actions';
import * as appActions from './app/actions';
import * as appSelectors from './app/selectors';
import * as usersSelectors from './users/selectors';
import * as questionsSelectors from './questions/selectors';
import * as reviewsSelectors from './reviews/selectors';
import * as photosSelectors from './photos/selectors';

export { default } from './store';
export { default as rootReducer } from './root-reducer';

export const selectors = {
  locations: locationsSelectors,
  places: placesSelectors,
  app: appSelectors,
  users: usersSelectors,
  questions: questionsSelectors,
  reviews: reviewsSelectors,
  photos: photosSelectors,
};

export const actions = {
  alerts: alertsActions,
  questions: questionsActions,
  reviews: reviewsActions,
  app: appActions,
  users: usersActions,
  visitorCenters: visitorCentersActions,
  locations: locationsActions,
  campgrounds: campgroundsActions,
  places: placesActions,
  photos: photosActions,
};

export const middlewares: Middleware[] = [
  fetchLocationsMiddleware,
  fetchPlacesMiddleware,
]

export type RootState = StateType<typeof rootReducer>;
